import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Popup from '@SiteComponents/Popup'
import Button from '@SiteComponents/Button'
import WorkspaceSelectionTable from '@SiteComponents/WorkspaceSelectionTable'
import Close from '@Images/close_create_workspace_popup.svg'

import {
  getSelectedAccountUserIds,
} from '@SiteModules/AccountUser/selectors'

import {
  getWorkspaces,
} from '@SiteModules/Workspace/selectors'

import {
  closeManageWorkspaceAccessPopup,
} from '@SiteModules/Popup/actions'

import {
  createWorkspaceUsers,
} from '@SiteModules/WorkspaceUser/actions'

import {
  unselectAccountUsers,
} from '@SiteModules/AccountUser/actions'

import './ManageWorkspaceAccessPopup.scss'

// Dimensions from // used in ManageWorkspaceAccessPopup.scss
const MANAGE_WORKSPACE_ACCESS_POPUP_PADDING_TOP = 24 // px
const MANAGE_WORKSPACE_ACCESS_POPUP_PADDING_BOTTOM = 24 // px
const MANAGE_WORKSPACE_ACCESS_POPUP_HEADER_HEIGHT = 24 // px
const MANAGE_WORKSPACE_ACCESS_POPUP_HEADER_MARGIN_BOTTOM = 32 // px
const MANAGE_WORKSPACE_ACCESS_POPUP_BUTTON_WRAPPER_HEIGHT = 32 // px
const MANAGE_WORKSPACE_ACCESS_POPUP_BUTTON_WRAPPER_MARGIN_TOP = 32 // px

const REMAINING_POPUP_HEIGHT_BESIDES_TABLE = MANAGE_WORKSPACE_ACCESS_POPUP_PADDING_TOP +
  MANAGE_WORKSPACE_ACCESS_POPUP_PADDING_BOTTOM +
  MANAGE_WORKSPACE_ACCESS_POPUP_HEADER_HEIGHT +
  MANAGE_WORKSPACE_ACCESS_POPUP_HEADER_MARGIN_BOTTOM +
  MANAGE_WORKSPACE_ACCESS_POPUP_BUTTON_WRAPPER_HEIGHT +
  MANAGE_WORKSPACE_ACCESS_POPUP_BUTTON_WRAPPER_MARGIN_TOP

const ManageWorkspaceAccessPopup: React.FC = () => {
  const dispatch = useDispatch()

  const [selectedWorkspaceIds, setSelectedWorkspaceIds] = useState<number[]>([])

  const selectedAccountUserIds = useSelector(getSelectedAccountUserIds)
  const workspaces = useSelector(getWorkspaces)

  const numberOfSelectedAccountUsers = selectedAccountUserIds.length
  const shouldBlockAddingMembersButton = selectedWorkspaceIds.length === 0
  const popupClassName='ManageWorkspaceAccessPopup'

  const handleAddMembers = () => {
    dispatch(createWorkspaceUsers({ accountUserIds: selectedAccountUserIds, workspaceIds: selectedWorkspaceIds }))
    dispatch(closeManageWorkspaceAccessPopup())
    dispatch(unselectAccountUsers())
  }

  const handleCancel = () => {
    dispatch(closeManageWorkspaceAccessPopup())
  }

  const renderButtons = () => {
    return (
      <div className="ManageWorkspaceAccessPopup__button-wrapper">
        <Button
          styleType="gray-subtle"
          size="small"
          caption="Cancel"
          onClick={handleCancel}
          icon={<Close/>}
        />
        <Button
          styleType="brand"
          size="small"
          caption="Add Members"
          onClick={handleAddMembers}
          disabled={shouldBlockAddingMembersButton}
        />
      </div>
    )
  }

  const renderWorkspaceSelectionTable = () => {
    return (
      <WorkspaceSelectionTable
        workspaces={workspaces}
        selectedWorkspaceIds={selectedWorkspaceIds}
        setSelectedWorkspaceIds={setSelectedWorkspaceIds}
        popupClassName={popupClassName}
        remainingPopupHeight={REMAINING_POPUP_HEIGHT_BESIDES_TABLE}
        showNumberOfProjects
      />
    )
  }

  return (
    <Popup
      className={popupClassName}
      closePopup={handleCancel}
    >
      <div className="ManageWorkspaceAccessPopup__header">
        {numberOfSelectedAccountUsers === 1 ? 'Add 1 member to...' : `Add ${numberOfSelectedAccountUsers} members to...`}
      </div>
      {renderWorkspaceSelectionTable()}
      {renderButtons()}
    </Popup>
  )
}

export default ManageWorkspaceAccessPopup
